import React from "react";
import { Link, useLocation } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";
import Brands from "./brands";
import VehicleModels from "./vehicleModels";
import TypesVehicles from "./typesVehicles/typesVehicles";

function BrandsModels() {
  const location = useLocation();

  // Obtener tab desde query param, ej: ?tab=model
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab") || "brand";

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Catálogos</li>
            <li className="breadcrumb-item active">Marcas, modelos y tipos</li>
          </ol>
          <h1 className="page-header mb-0">Marcas, modelos y tipos</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>
              Listado de Marcas, modelos y tipos de Vehículos
            </PanelHeader>
            <PanelBody>
              <Tabs defaultActiveKey={tab} className="mb-3">
                <Tab eventKey="brand" title="Marcas">
                  <Brands />
                </Tab>
                <Tab eventKey="model" title="Modelos">
                  <VehicleModels />
                </Tab>
                <Tab eventKey="typesVehicles" title="Tipos de vehículos">
                  <TypesVehicles />
                </Tab>
              </Tabs>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default BrandsModels;